// extracted by mini-css-extract-plugin
export default {"text":"statusItem_text__mZPI7","title":"statusItem_title__u+WJq","description":"statusItem_description__+BSmg"};